import {createFileRoute, useSearch} from '@tanstack/react-router'
import {WalletDeposit} from "@/components/wallet/WalletDeposit/WalletDeposit.tsx"
import { z } from 'zod'

const schema = z.object({
  id: z.string().optional(),
})

export const Route = createFileRoute('/_mainLayout/wallet/deposit/')({
  component: RouteComponent,
  validateSearch: schema,
})

function RouteComponent() {
  const params = useSearch({ from: '/_mainLayout/wallet/deposit/' })
  return <WalletDeposit {...params} />
}
